<template>
  <el-menu-item-group :title="Language(this.menuGroupName)">
    <template v-for="item in this.menuData">
      <template v-if="item.children">
        <el-submenu
          :label="Language(item.name)"
          :value="item.id"
          :key="item.type + item.id"
          :index="item.id"
          :title="Language(item.name)"
        >
          <template slot="title">
            <i :class="getIcon(item.picCode)" class="iconfont"></i>
            <span>{{ Language(item.name) }}<b class="menu_num" v-if="item.qty && (item.qty > 0)">{{item.qty>99?'99+':item.qty}}</b></span>
          </template>
          <menu-tree :menuData="item.children" :menuGroupName="item.name" @menuClick="navListClick"></menu-tree>
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item
          @click="navListClick(item)"
          :label="Language(item.name)"
          :value="item.id"
          :key="item.type + item.id"
          :index="item.name"
          :title="Language(item.name)"
        >
          <template slot="title">
            <i :class="getIcon(item.picCode)" class="iconfont"></i>
            <span>{{ Language(item.name) }}<b class="menu_num" v-if="item.qty && (item.qty > 0)">{{item.qty>99?'99+':item.qty}}</b></span>
          </template>
        </el-menu-item>
      </template>
    </template>
  </el-menu-item-group>
</template>
<script>
import "./css/LeftNav.css";
export default {
  name: "menuTree",
  props: ['menuData', 'menuGroupName'],
  data() {
    return {
      
    };
  },
  created() {

  },
  mounted() {

  },
  computed: {
    
  },
  methods: {
    getIcon(item) {
      //设置菜单组图标
      return item == "" || item == null ? "icon-caidanzumorentupian" : item;
    },
    navListClick(item) {
      this.$emit('menuClick', item)
    },
  },

  watch: {

  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// menuTree.vue?6bfc841b